import { useEffect, useRef } from 'react';
import { useEditorStore } from '../editorStore';

const AUTOSAVE_DELAY = 2000; // 2 seconds

export function useAutoSave() {
  const saveTimeout = useRef<NodeJS.Timeout>();
  const nodes = useEditorStore(state => state.nodes);
  const edges = useEditorStore(state => state.edges);
  const autoSave = useEditorStore(state => state.autoSave);
  const saveWorkflow = useEditorStore(state => state.saveWorkflow);
  const isSaving = useEditorStore(state => state.isSaving);
  const workflowId = useEditorStore(state => state.workflowId);

  useEffect(() => {
    if (!autoSave || !workflowId || isSaving) return;

    // Clear any existing timeout
    if (saveTimeout.current) {
      clearTimeout(saveTimeout.current);
    }

    // Set new timeout for auto-save
    saveTimeout.current = setTimeout(() => {
      saveWorkflow().catch(error => {
        console.error('Auto-save failed:', error);
      });
    }, AUTOSAVE_DELAY);

    // Cleanup timeout on unmount or when dependencies change
    return () => {
      if (saveTimeout.current) {
        clearTimeout(saveTimeout.current);
      }
    };
  }, [nodes, edges, autoSave, workflowId, isSaving, saveWorkflow]);
}
